/**
 * Store links for the mobile app — empty in prod until store listings go
 * live (Apple Developer + Play Console accounts are user-action blockers,
 * see KNOWN-ISSUES.md "Mobile app"). Every marketing surface referencing
 * these MUST render nothing (or the "coming soon" fallback) when both are
 * empty — never a store badge pointing at a dead/placeholder URL.
 */
export const iosUrl = (import.meta.env.VITE_IOS_APP_URL as string | undefined)?.trim() || '';
export const androidUrl = (import.meta.env.VITE_ANDROID_APP_URL as string | undefined)?.trim() || '';
export const hasAnyStoreLink = !!iosUrl || !!androidUrl;
